import React from 'react'

export const NoImageIcon = React.forwardRef<SVGSVGElement>((props, ref): React.ReactElement => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M4.6875 14.25L6.68712 12.0736C7.27495 11.4338 8.2817 11.4257 8.87976 12.0559L15.7807 19.3281"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0308 14.9531L13.5072 13.1955C14.1066 12.4818 15.2049 12.4818 15.8043 13.1955L18.5933 16.5156"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="4.46826"
        y="4.46826"
        width="15.125"
        height="15.125"
        rx="4.125"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path d="M3 21L21 3" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  )
})

export default NoImageIcon
